import { render, staticRenderFns } from "./subAddressAdd.vue?vue&type=template&id=0c1b43f4&scoped=true"
import script from "./subAddressAdd.vue?vue&type=script&lang=js"
export * from "./subAddressAdd.vue?vue&type=script&lang=js"
import style0 from "./subAddressAdd.vue?vue&type=style&index=0&id=0c1b43f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b43f4",
  null
  
)

export default component.exports